export type QuizCategory = "SAFETY" | "FINANCE" | "HEALTH" | "LOCAL"

export const QUIZ_CATEGORY_LABELS: Record<QuizCategory, string> = {
  SAFETY: "Безопасность",
  FINANCE: "Финансы",
  HEALTH: "Здоровье",
  LOCAL: "Город",
}

const QUIZ_CATEGORY_SET = new Set<string>(Object.keys(QUIZ_CATEGORY_LABELS))

export function normalizeQuizCategory(value: unknown): QuizCategory | undefined {
  if (typeof value !== "string" || !value.trim()) return undefined
  const upper = value.trim().toUpperCase()
  return QUIZ_CATEGORY_SET.has(upper) ? (upper as QuizCategory) : undefined
}

export function getQuizCategoryLabel(category: QuizCategory | undefined): string | null {
  if (!category) return null
  return QUIZ_CATEGORY_LABELS[category] ?? null
}
